import React, { useState } from 'react';
import PropTypes from 'prop-types';
import FormField from '../FormField';

const NAME_REGEX = /^[\p{L}\s,.'`-]+$/u;
const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

const validateName = (value) => {
  if (!value) return null;
  if (!NAME_REGEX.test(value) || value.startsWith('-')) {
    return 'Invalid name. Name cannot contain special characters or numbers.';
  }
  return null;
};

const validateEmail = (value) => {
  if (!value) return null;
  if (!EMAIL_REGEX.test(value)) return 'Invalid email. Please enter a valid email address (e.g. name@example.com).';
  return null;
};

const AccountInfoFields = ({
  formData,
  handleInputChange,
  loading,
  countryOptions,
  isLoadingCountries,
  checkEmailExists,
  isClaimFlow
}) => {
  const [emailError, setEmailError] = useState(null);
  const [firstNameError, setFirstNameError] = useState(null);
  const [lastNameError, setLastNameError] = useState(null);

  const handleEmailBlur = () => {
    const error = validateEmail(formData.email);
    setEmailError(error);
    if (!error && checkEmailExists) {
      checkEmailExists();
    }
  };

  return (
  <>
    <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-5">
      <FormField
        label="Email"
        placeholder="Enter email address"
        value={formData.email}
        onChange={(value) => {
          handleInputChange('email', value);
          if (emailError) setEmailError(validateEmail(value));
        }}
        onBlur={handleEmailBlur}
        type="email"
        disabled={loading}
        error={emailError}
      />
      <FormField
        label="First name"
        placeholder="Enter first name"
        value={formData.firstName}
        onChange={(value) => {
          handleInputChange('firstName', value);
          if (firstNameError) setFirstNameError(validateName(value));
        }}
        onBlur={() => setFirstNameError(validateName(formData.firstName))}
        disabled={loading}
        error={firstNameError}
      />
      <FormField
        label="Last name"
        placeholder="Enter last name"
        value={formData.lastName}
        onChange={(value) => {
          handleInputChange('lastName', value);
          if (lastNameError) setLastNameError(validateName(value));
        }}
        onBlur={() => setLastNameError(validateName(formData.lastName))}
        disabled={loading}
        error={lastNameError}
      />
    </div>
    <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-8">
      <FormField
        label="Country of residence"
        placeholder="Select country"
        value={formData.country}
        onChange={(value) => handleInputChange('country', value)}
        type="autocomplete"
        options={countryOptions}
        disabled={loading || isLoadingCountries}
      />
      <FormField
        label="Mobile phone"
        placeholder="Enter phone number"
        value={formData.mobilePhone}
        onChange={(value) => handleInputChange('mobilePhone', value)}
        type="phone"
        defaultCountryCode={formData.country || 'US'}
        disabled={loading}
      />
    </div>
  </>
  );
};

AccountInfoFields.propTypes = {
  formData: PropTypes.object.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  countryOptions: PropTypes.array.isRequired,
  isLoadingCountries: PropTypes.bool.isRequired,
  checkEmailExists: PropTypes.func,
  isClaimFlow: PropTypes.bool
};

export default AccountInfoFields;
